import { searchMembersQuery } from "@/api/member";
import { supplierQuery } from "@/api/supplier";
import { supporterQuery } from "@/api/supporter";
import { queryClient } from "@/api/utils";
import { router } from "@/router";
import { saveHref } from "@/utils/assume-role";
import { RichSearchResult } from "@givenwell/command-palette";

// sppl_cmfonoo2200qb0800rvfqxgzk
// supp_cm8nrfrr700450762qkjzpx40
// f413a892-da57-41eb-8133-1811bf3cfeb3
// trent@trents.computer

const memberIdRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
const memberEmailRegex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/i;

const Prefix = {
  Supplier: "sppl_",
  Supporter: "supp_",
};

export const idSearchCommands: RichSearchResult[] = [
  {
    title: "Supplier ID",
    when: searchText => searchText.startsWith(Prefix.Supplier),
    result: async id => (await queryClient.ensureQueryData(supplierQuery(id))).name,
    actions: id => [
      {
        title: `Assume Role`,
        onAction: ({ close }) => {
          saveHref();
          router.navigate({
            to: "/supplier/$supplierId",
            params: { supplierId: id },
          });
          close();
        },
      },
    ],
  },
  {
    title: "Supporter ID",
    when: searchText => searchText.startsWith(Prefix.Supporter),
    result: async id => (await queryClient.ensureQueryData(supporterQuery(id))).name,
    actions: id => [
      {
        title: `Assume Role`,
        onAction: ({ close }) => {
          saveHref();
          router.navigate({
            to: "/supporter/$supporterId",
            params: { supporterId: id },
          });
          close();
        },
      },
    ],
  },
  {
    title: "Member ID",
    when: searchText => memberIdRegex.test(searchText),
    result: async id => {
      const member = (await queryClient.ensureQueryData(searchMembersQuery(id))).members[0];
      if (!member) return "Not Found";
      return member.given_name + " " + member.family_name;
    },
    actions: id => [
      {
        title: `View Member`,
        onAction: ({ close }) => {
          router.navigate({
            to: "/admin/members/$memberId",
            params: { memberId: id },
          });
          close();
        },
      },
    ],
  },
  {
    title: "Member Email",
    when: searchText => memberEmailRegex.test(searchText),
    result: async email => {
      const members = (await queryClient.ensureQueryData(searchMembersQuery(email))).members;
      const member = members.find(m => m.email.toLowerCase() === email.toLowerCase());
      if (!member) return "Not Found";
      return member.given_name + " " + member.family_name;
    },
    actions: email => {
      const members = queryClient.getQueryData(searchMembersQuery(email).queryKey)?.members || [];
      const member = members.find(m => m.email.toLowerCase() === email.toLowerCase());
      if (!member) return [];
      const id = member.member_id;
      return [
        {
          title: `View Member`,
          onAction: ({ close }) => {
            router.navigate({
              to: "/admin/members/$memberId",
              params: { memberId: id },
            });
            close();
          },
        },
      ];
    },
  },
];
